import { cva } from 'class-variance-authority';

const menuDividerBaseStyles = ['w-full', 'h-0.5'];

const menuDividerStylesSAG = cva([
  ...menuDividerBaseStyles,
  'bg-[#E8E8E3]',
  'dark:bg-[#000028]',
]);

const menuDividerStylesSHS = cva([
  ...menuDividerBaseStyles,
  'bg-[#e6e6e6]',
  'dark:bg-[#4d4d4d]',
]);

export { menuDividerStylesSAG, menuDividerStylesSHS };
